import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/base/SchemaOrg';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import SEOSection from './components/SEOSection';
import TrustSection from './components/TrustSection';
import AboutSection from './components/AboutSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <SchemaOrg
        data={{
          '@type': 'Organization',
          name: 'Hipobuy Spreadsheet',
          url: 'https://hipobuyspread.casa/',
          description: 'Hipobuy Spreadsheet is an organized product discovery database that aggregates curated shopping resources across footwear, apparel, accessories, and lifestyle categories.',
          sameAs: [
            'https://kaspreadsheet.com',
          ],
        }}
      />
      <Navbar />
      <main>
        <article>
          <HeroSection />
          <CategoryGrid />
          <SEOSection />
          <TrustSection />
          <AboutSection />
          <CTASection />
        </article>
      </main>
      <Footer />
    </div>
  );
}